/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:error
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社        | 新規作成
//================================================================================
 */
export const error = {
	namespaced: true,
	state: {
		errFlg: false,
		errMsg: [],
		inputErrMsg: [{}],
		inputErrFlg: false
	},
	getters: {
		// エラーフラグを取得します
		isErrFlg(state) {
			return state.errFlg;
		},
		// エラーメッセージを取得します
		getErrMsg(state) {
			return state.errMsg;
		},
		// 入力エラーフラグを取得します
		isInputErrFlg(state) {
			return state.inputErrFlg;
		},
		// 入力エラーメッセージを取得します
		getInputErrMsg(state) {
			return state.inputErrMsg;
		}
	},
	mutations: {
		// メッセージ削除
		clear(state) {
			state.errFlg = false;
			state.errMsg = [];
			state.inputErrMsg = [];
			state.inputErrFlg = false;
		},
		// メッセージ追加
		setError(state, msg) {
			state.errFlg = true;
			state.errMsg.push(msg);
		},
		// 入力メッセージ追加
		setInputError(state, info) {
			state.errFlg = true;
			state.inputErrMsg.push({key: info.id, value : info.msg});
			state.inputErrFlg = true;
		},
		// 指定されたメッセージを削除します
		deleteAt(state, msg) {
			for ( var j = 0; j < state.errMsg.length; j++ ) {
				if ( state.errMsg[j] === msg ) {
					state.errMsg.splice(j, 1);
				}
			}
			if(state.errMsg.length == 0) {
				state.errFlg = false;
			}
		},
		// 指定されたメッセージをGroupId単位で削除します
		deleteGroupId(state, id) {
			state.inputErrMsg = state.inputErrMsg.filter(function( item ) {
				return item.key != id;
			});

			if(state.inputErrMsg.length == 0) {
				state.errFlg = false;
			}
		}
	},
	actions: {
	},
	modules: {
	}
}